import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useViewSingleUser } from "../../hooks/users/viewSingleUser";
import { ArrowLeft } from "lucide-react";
import FallbackImage from "../../components/common/fallbackImage";

const ViewUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, isError } = useViewSingleUser(id);

  const user = data?.data?.user || data?.data || data?.user || data || {};

  if (isLoading) return <div>Loading user...</div>;
  if (isError) return <div>Error loading user</div>;

  return (
    <>
      <h5>
        <button className="back-btn" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Back to Users
        </button>
      </h5>

      {/* <h2 style={{ color: "#5C308D", marginBottom: "20px" }}>
        {" "}
        {client?.name || "Client"} Details
      </h2> */}
      <div className="page-body" style={{ marginTop: 30 }}>
        <div
          className="client-view-card"
          style={{
            padding: "20px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            background: "#fff",
            width: "100%",
          }}
        >
          {user?.profilePicture && (
            <FallbackImage
              src={user.profilePicture}
              alt="user"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "50%",
                marginBottom: "20px",
              }}
            />
          )}

          <div className="client-grid">
            <div className="field">
              <span className="label">User Name</span>
              <span className="value">{user?.name || "-"}</span>
            </div>

            <div className="field">
              <span className="label">Email</span>
              <span className="value">{user?.email || "-"}</span>
            </div>

            <div className="field">
              <span className="label">Phone</span>
              <span className="value">{user?.phone || "-"}</span>
            </div>
            <div className="field">
              <span className="label">Country</span>
              <span className="value">{user?.country || "-"}</span>
            </div>
            <div className="field">
              <span className="label">Designation</span>
              <span className="value">{user?.designation || "-"}</span>
            </div>

            {/* <div className="field">
              <span className="label">Password</span>
              <span className="value">{user?.password || "-"}</span>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewUser;
